var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u:home-alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9433 1.73914C6.37528 1.73914 3.47827 4.63615 3.47827 8.20416C3.47827 10.0242 4.42148 11.8817 5.60288 13.4357C7.25282 15.6056 9.31517 17.1752 9.32538 17.1831C9.69048 17.4607 10.1961 17.4607 10.5612 17.1831C10.5714 17.1752 12.6338 15.6056 14.2837 13.4357C15.4651 11.8817 16.4083 10.0242 16.4083 8.20416C16.4083 4.63615 13.5113 1.73914 9.9433 1.73914ZM9.9433 2.41967C13.136 2.41967 15.7278 5.01146 15.7278 8.20416C15.7278 9.88439 14.8326 11.5895 13.742 13.0237C12.1455 15.1234 10.1495 16.6414 10.1495 16.6414C10.028 16.7339 9.85891 16.7339 9.73744 16.6414C9.73744 16.6414 7.74111 15.1234 6.14458 13.0237C5.05404 11.5895 4.1588 9.88439 4.1588 8.20416C4.1588 5.01146 6.7506 2.41967 9.9433 2.41967Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94251 5.14185C8.25241 5.14185 6.88013 6.51413 6.88013 8.20423C6.88013 9.89432 8.25241 11.2666 9.94251 11.2666C11.6326 11.2666 13.0049 9.89432 13.0049 8.20423C13.0049 6.51413 11.6326 5.14185 9.94251 5.14185ZM9.94251 5.82238C11.257 5.82238 12.3244 6.88979 12.3244 8.20423C12.3244 9.51867 11.257 10.5861 9.94251 10.5861C8.62807 10.5861 7.56066 9.51867 7.56066 8.20423C7.56066 6.88979 8.62807 5.82238 9.94251 5.82238Z",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTag);
export default __webpack_public_path__ + "static/media/OtherTag.38efb451b3618c3a783bf6dc471ec560.svg";
export { ForwardRef as ReactComponent };